// 9fbef606107a605d69c0edbcd8029e5d
import Styled from 'styled-components';

export const ShopAllLink = Styled.div`
  margin-left: 10px;
  @media ${(props) => props.theme.mediaQuery.large} {
    height: auto;
  }
  a {
    height: 100%;
  }
`;
export const ShopAllMobileHeader = Styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 42px;
  h3 {
    padding: 10px 0;
    font-family: Nunito;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
  }
  a {
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
  }
`;
export const ShopAllContent = Styled.div`
  height: 100%;
  width: 166px;
  background-color: rgb(22, 47, 66);
  color: rgb(255, 255, 255);
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  @media ${(props) => props.theme.mediaQuery.large} {
    width: 262px;
    white-space: pre-wrap;
  }
  @media ${(props) => props.theme.mediaQuery.small} {
    white-space: pre-wrap;
  }
  .shop-all-label {
    font-family: Nunito;
    font-size: 18px;
    font-weight: bold;
    text-decoration: underline;
    width: 108px;
    text-align: center;
    line-height: 24px;
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-right: 5px;
    }

  }
`;

export const ShopAllContentMobile = Styled.div`
  display: flex;
  gap: 0px;
  align-items: center;
  .shop-all-label-mobtab{
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
    font-family: Nunito;
    font-size: 14px;
    font-weight: bold;
  }
`;
